import { render } from "./returnProcess.vue?vue&type=template&id=7dd8dfe3&scoped=true"
import script from "./returnProcess.vue?vue&type=script&lang=js"
export * from "./returnProcess.vue?vue&type=script&lang=js"

import "./returnProcess.vue?vue&type=style&index=0&id=7dd8dfe3&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\Desktop\\Vue CLI\\new-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd8dfe3"]])

export default __exports__